import { render, staticRenderFns } from "./PersonaEdit.vue?vue&type=template&id=ca95fe0c&scoped=true&"
import script from "./PersonaEdit.vue?vue&type=script&lang=js&"
export * from "./PersonaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca95fe0c",
  null
  
)

export default component.exports